import { CommunicationLogService } from './../../../services/communication-log.service';
import { CommunicationLog } from './../../../entities/CommunicationLog';
import { TranslationService } from 'app/services/translation.service';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, Renderer2, ViewChild, ViewChildren, QueryList, OnDestroy} from '@angular/core';
import { Task, TaskLevel } from '../../../entities/Task';
import { AppFile } from '../../../entities/AppFile';
import { FileService } from '../../../services/file.service';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { environment } from '../../../../environments/environment';
import { Responsible } from '../../../entities/SalesPerson';
import * as moment from 'moment';
import { productModels } from '../../../../environments/environment';
import { AppConfig } from '../../../app.config';
import { SalesPersonService } from '../../../services/sales-person.service';
import { ItemUsageService } from '../../../services/item-usage.service';
import { ItemUsage } from '../../../entities/ItemUsage';
import { RequisitionLineService } from '../../../services/requisition-line.service';
import { RequisitionLine } from '../../../entities/RequisitionLine';
import { SessionService } from '../../../services/session.service';
import { MaintenanceObjectListConfig } from '../../../entities/enums/MaintenanceObjectListConfig';
import { TranslationPipe } from "app/pipes/TranslationPipe";
import { Translation } from 'app/entities/Translation';
import { MaintenanceObject } from 'app/entities/MaintenanceObject';
import { TaskActivityService } from 'app/services/task-activity.service';
import { Observable, Subscription } from 'rxjs';
import { TaskActivity } from 'app/entities/TaskActivity';
import { SideSwitch } from "app/entities/enums/ModalRightSide";

declare var $: any;

enum MobileTaskSection {
  Details = 'details',
  Activities = 'activities',
  Items = 'items',
  CommunicationLog = 'communicationLog'
}

@Component({
  selector: 'app-modal-task',
  templateUrl: './modal-task.component.html',
  styleUrls: ['./modal-task.component.css']
})
export class ModalTaskComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input('chosenTask')
  set chosenTask(task: any) {
    if (task != null) {
      this._chosenTask = Object.assign({}, task);
      this.initCustomStyle();
      this.initDatapickers();
      this.currentMobileSection = MobileTaskSection.Details;
      this.getFiles(task);
      this.getItemUsage(task);
      this.getRequisitionLines(task);
      this.findSelectedCompany();
      if(this._chosenTask.No){
        this.getCommunicationLogs(this._chosenTask.No)
      }
      $('#taskActivityHistoryModal').modal('hide');
      this.showActivityHistory = false;
      this.selectedActivityHistoryTitle = '';
      this.taskActivityHistory = [];
      if(this.taskActivitiesRef){
        this.checkActivitiesForInvalidValues()
      }

      this.originalTaskLevel = TaskLevel[this._chosenTask.Task_Level];

      if (this._chosenTask.Status === 'Completed' && this._chosenTask.Completed_By_Stamp != '' &&
        ((this._chosenTask.Company_Reference != this.sessionService.getSelectedCompany()) ||
          (this._chosenTask.Company_Reference == this.sessionService.getSelectedCompany() && this._chosenTask.Task_Level !== TaskLevel.OTS))) {

        let salesperson = this.salespersons.find(person => person.Code === this._chosenTask.Completed_By)
        if (!salesperson)
          this.originalShowCompletedByStamp = true;
      }

      this.updateMobileLayout();
    }
  }

  @Input()
  loggedInUserNo: string;

  @Input('notificationAlreadyCreated')
  set NotificationAlreadyCreated(result: any) {
    this.notificationAlreadyCreated = result;
  }

  @Input()
  set Companies(value: any) {
    this.companies = value;

    this.findSelectedCompany();
  }

  @Output()
  public updateTaskEmitter = new EventEmitter();

  @Output()
  public updateActivitiesEmitter = new EventEmitter();

  @ViewChildren('taskActivitiesRef') taskActivitiesRef: QueryList<ElementRef>;
  @ViewChildren('fileElements') fileElements: QueryList<ElementRef>;

  @ViewChild('fileChooserInput') private fileChooserValue: ElementRef;


  public textFieldValue: string;
  public isExpandedTextFieldAvailable: boolean;
  public _chosenTask: Task = new Task();
  public taskLevels = Object.keys(TaskLevel)
  public companies: any[];
  public itemUsages: ItemUsage[];
  public requisitionItems: RequisitionLine[]
  public itemUsageTitle: string = this.translationPipe.transform('ItemConsumptionAndOrders');
  public activityErrorMessage: string = this.translationPipe.transform('ActivityErrorMessage')
  _maintenanceObjectConfiguration = MaintenanceObjectListConfig;
  public selectedConfiguration = this._maintenanceObjectConfiguration.PickingList;
  public hasCreationError: boolean = false;
  public creationErrorMessage: string;
  public originalShowCompletedByStamp: boolean = false;
  public selectedCompany: any = null;
  public filesToDownload: AppFile[] = [];
  public filesToUpload: AppFile[] = [];
  public loading: boolean;
  public dummyStart: any;
  public dummyEnd: any;
  public dummyCompletion: any;
  public fileRelatedErrorExists: boolean;
  public startDatePickerOptions: IMyDpOptions;
  public endDatePickerOptions: IMyDpOptions;
  public completionDatePickerOptions: IMyDpOptions;
  public productModels = productModels;
  public currentProductModel: any;
  public salespersons: Responsible[];
  public currentResourceNo: string;
  public notificationAlreadyCreated: boolean;
  public modal_dialog_custom_style: any = {};
  public main_modal_body_custom_style: any = {};
  public main_modal_body_custom_class: any = '';
  public acti_modal_body_custom_class: any = '';
  public item_modal_body_custom_class: any = '';
  public showCreateItemUsage: boolean;
  public showItemUsages: boolean = true;
  public showCreateItemOrder: boolean;
  private originalTaskLevel: TaskLevel;
  private chosenProperty: string;
  public editTitle: boolean = false;
  fileUploadErrorResponse: Response;
  _maximumQuantityLength = 9999;
  translations: Map<string, Translation>;
  translationsLoaded: boolean = false;
  public isMaintenanceSelectionReady: boolean = true;
  public isMaintenanceObjectPickerShown: boolean = false;
  listOfChangedMaintenanceObjects: MaintenanceObject[] = [];
  hideImagePreview: boolean = true;
  previewImageUrl;
  imagePosition: {top: number, left:number} = {top: 0, left: 0}
  public sideswitch = SideSwitch;
  //set the view to Item usage as default
  currentSide: SideSwitch = SideSwitch.ItemUsage;
  pendingCommunicationLog: string;
  communicationLogs: CommunicationLog[] = [];
  showActivityHistory: boolean = false;
  public selectedActivityHistoryTitle: string = '';
  taskActivityHistory: TaskActivity[] = [];
  onceSupported = false;
  taskActivitiesSub = new Subscription();
  public mobileTaskSections = MobileTaskSection;
  public currentMobileSection: MobileTaskSection = MobileTaskSection.Details;
  public isMobileLayout: boolean = false;



  constructor(private sessionService: SessionService,
    private fileService: FileService,
    private appConfig: AppConfig,
    private salesPersonService: SalesPersonService,
    private itemUsageService: ItemUsageService,
    private requisitionLineService: RequisitionLineService,
    private translationPipe: TranslationPipe,
    private translationService: TranslationService,
    private renderer: Renderer2,
    private taskActivityService: TaskActivityService,
    private communicationLogService: CommunicationLogService
  ) {
    this.currentProductModel = this.appConfig.getConfig('productModel');

  }

  ngOnInit() {
    this.getSalesPersons();
    this.translationService.loadTranslations();
    this.translationService.translationsSub.subscribe(() => {
      this.translationsLoaded = true
    })

    this.updateMobileLayout();

    if (this.isSelectedCompanyOTS) {
      this.currentSide = this.sideswitch.CommunicationLog;
    }
  }

  ngAfterViewInit(): void {
    // Initialize the popover after view
    $('[data-toggle="popover"]').popover();
    this.addEscapeListenerForClosingModals();
  }

  ngOnDestroy(): void {
    this.taskActivitiesSub.unsubscribe();
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateMobileLayout();
  }

  // get the display property of an element
  getDisplayProperty(id: string): string {
    const element: HTMLElement = document.getElementById(id);
    return window.getComputedStyle(element).getPropertyValue('display');
  }

  /**
   * The function "checkActivitiesForInvalidValues" subscribes to changes in a list of elements and
   * calls another function to set error messages for invalid activity values.
   */
  checkActivitiesForInvalidValues(){
    this.taskActivitiesSub = this.taskActivitiesRef.changes.subscribe(elements => {
      const taskActivities = this._chosenTask.TaskActivities
      const activityList = elements.toArray()
      this.setErrorForInvalidActivityValues(taskActivities, activityList)
    })
  }



 /**
  * The function sets an error class for task activities that have a maximum reading different from the
  * minimum reading.
  * @param {TaskActivity[]} taskActivities - An array of TaskActivity objects.
  * @param {ElementRef[]} activityList - activityList is an array of ElementRef objects. Each
  * ElementRef object represents a DOM element in the template.
  */
  setErrorForInvalidActivityValues(taskActivities: TaskActivity[], activityList: ElementRef[]){
    if(!taskActivities || activityList.length <= 0){
      return;
    }
    taskActivities.forEach((taskActivity: TaskActivity, index) => {
      if(taskActivity.Max_Reading !== taskActivity.Min_Reading){
        this.setErrorClass(taskActivity, activityList[index].nativeElement)
      }
    })
  }

  //Add an escape listener that closes the correct modal
  addEscapeListenerForClosingModals() {
    window.addEventListener('keydown', (ev) => {
      if (ev.code !== 'Escape') {
        return
      }
      if (this.getDisplayProperty('maintenanceObjectPicker') === 'none') {
        document.getElementById('closeModalTaskBtn').click();
      } else {
        document.getElementById('innerModalCloseButton').click();
      }
      this.reset();
    });
  }

  public get isSelectedCompanyOTS() {
    return this.sessionService.getCompanyType() === TaskLevel.OTS;
  }

  public get isChosenTaskLevelOTS() {
    return this._chosenTask.Task_Level === TaskLevel.OTS;
  }

  public setMobileSection(section: MobileTaskSection) {
    this.currentMobileSection = section;
    if (section === MobileTaskSection.Items) {
      this.currentSide = this.sideswitch.ItemUsage;
    } else if (section === MobileTaskSection.CommunicationLog) {
      this.currentSide = this.sideswitch.CommunicationLog;
    }
  }

  //TODO: Create enum for selector or someone add documentation for the numbers.
  public toggleShowItemUsageContent(selector: number) {
    if (selector === 2 && this.listOfChangedMaintenanceObjects.length !== 0) {
      // If the user clicks cancel to the change detected prompt, then dont switch back to the parent menu
      if (!this.alertUserOfChanges()) {
        return;
      }
    }
   this.hasCreationError = false;
    this.creationErrorMessage = '';

    this.showCreateItemUsage = selector == 1;
    this.showItemUsages = selector == 2;
    this.showCreateItemOrder = selector == 3;

    switch (selector) {
      case 1: {
        this.itemUsageTitle = this.translationPipe.transform('UseItem');
        break;
      }
      case 2: {
        this.itemUsageTitle = this.translationPipe.transform('ItemsUsed');
        break;
      }
      case 3: {
        this.itemUsageTitle = this.translationPipe.transform('OrderItem');
        break;
      }
    }
  }

  private updateMobileLayout() {
    const shouldUseMobileLayout = window.innerWidth <= 768;
    this.isMobileLayout = shouldUseMobileLayout;

    if (!shouldUseMobileLayout) {
      return;
    }

    if (
      this.currentMobileSection === MobileTaskSection.Activities &&
      (!this._chosenTask || !this._chosenTask.TaskActivities || this._chosenTask.TaskActivities.length === 0)
    ) {
      this.currentMobileSection = MobileTaskSection.Details;
    }
  }

  //returns true if the user clicks OK to the prompt;
  alertUserOfChanges() {
    if (confirm("Der er foretaget ændringer i antal varer, der ikke er gemt. Hvis du fortsætter, slettes disse indtastninger. Ønsker du at forsætte?")) {
      this.clearChangedQuantityList();
      return true;
    }
    return false;
  }

  public changeConfiguration() {
    this.creationErrorMessage = '';
    this.hasCreationError = false;
    this.selectedConfiguration = this._maintenanceObjectConfiguration.PickingList;
  }

  private initCustomStyle() {
    //TODO: Remove productModels?
    //TODO: Move CSS into style file?
    if (this.currentProductModel == productModels.Maintenance && this._chosenTask.TaskActivities != null && this._chosenTask.TaskActivities.length > 0) {
      this.modal_dialog_custom_style = this.isSelectedCompanyOTS ? { 'width': '1100px' } : { 'width': '1700px' };//1000
      this.main_modal_body_custom_style = { 'float': 'right', 'border-bottom': '1px solid #e5e5e5', 'margin-bottom': '10px' };
      this.main_modal_body_custom_class = this.isSelectedCompanyOTS ? 'col-xs-7; col-sm-7; col-md-7; col-lg-6' : 'col-xs-4; col-sm-4; col-md-4; col-lg-4';
      this.acti_modal_body_custom_class = 'col-xs-4; col-sm-4; col-md-4; col-lg-4';
      this.item_modal_body_custom_class = this.isSelectedCompanyOTS ? 'col-xs-0; col-sm-0; col-md-0; col-lg-0' : 'col-xs-4; col-sm-4; col-md-4; col-lg-4';
    } else {
      this.modal_dialog_custom_style = { 'width': '1200px' };//600
      this.main_modal_body_custom_class = 'col-xs-7; col-sm-7; col-md-7; col-lg-6';
      this.acti_modal_body_custom_class = 'col-xs-4; col-sm-4; col-md-4; col-lg-4';
      this.item_modal_body_custom_class = 'col-xs-5; col-sm-5; col-md-5; col-lg-6';
    }
  }

  private initDatapickers() {
    this._chosenTask.end = moment(new Date(this._chosenTask.end).setDate(new Date(this._chosenTask.end).getDate())).format(environment.START_DATETIME_FORMAT);

    this.dummyStart = {
      date: {
        year: new Date(this._chosenTask.start).getFullYear(),
        month: new Date(this._chosenTask.start).getMonth() + 1,
        day: new Date(this._chosenTask.start).getDate()
      }
    };

    this.dummyEnd = {
      date: {
        year: new Date(this._chosenTask.end).getFullYear(),
        month: new Date(this._chosenTask.end).getMonth() + 1,
        day: new Date(this._chosenTask.end).getDate()
      }
    };

    this.dummyCompletion = {
      date: {
        year: new Date(this._chosenTask.Completed_Date_Time).getFullYear(),
        month: new Date(this._chosenTask.Completed_Date_Time).getMonth() + 1,
        day: new Date(this._chosenTask.Completed_Date_Time).getDate()
      }
    };

    this.setOptionsData();
  }

  public updateTask(chosenTask: Task) {
    let completedByPerson: Responsible = this.salespersons.find(sPerson => sPerson.Code === chosenTask.Completed_By);
    let responsiblePerson: Responsible = this.salespersons.find(resPerson => resPerson.Code === chosenTask.Responsible);
    let otsResponsible: Responsible = this.salespersons.find(otsResPerson => otsResPerson.Code === chosenTask.OTS_Responsible)

    if (completedByPerson) {
      chosenTask.Completed_By_Stamp = completedByPerson.Name;
    }

    if (responsiblePerson) {
      chosenTask.Responsible_Name = responsiblePerson.Name;
    }

    if (otsResponsible) {
      chosenTask.OTS_Responsible_Name = otsResponsible.Name;
    }

    this.updateTaskEmitter.emit(chosenTask);

    //TODO: Remove productModels?
    if (this.currentProductModel === productModels.Maintenance) {
      this.updateActivitiesEmitter.emit(chosenTask.TaskActivities);
    }

    this.reset();
  }

  public activityDoneBtnChange(taskActivity: TaskActivity, event, elementRef: HTMLLIElement) {
    const checked = event.target.checked;
    this.setErrorClass(taskActivity, elementRef);
    if (checked) {
      taskActivity.Carried_Out_By = sessionStorage.getItem('userNo');
    }
  }

  public taskActivityInputChange(taskActivity: TaskActivity, elementRef) {
    if (taskActivity.Reading != 0 && Number(taskActivity.Reading) != 0) {
      taskActivity.Carried_Out_By = sessionStorage.getItem('userNo');
      taskActivity.Done = true;
      this.setErrorClass(taskActivity, elementRef);
    } else {
      taskActivity.Done = false;
    }
  }

  setErrorClass(taskActivity: TaskActivity, elementRef: HTMLLIElement) {
    if (this.exceedsBoundryValues(taskActivity) && taskActivity.Done) {
      this.renderer.addClass(elementRef, 'error');
    } else {
      this.renderer.removeClass(elementRef, 'error')
    }
  }

  public onFileChange($event) {
    this.fileRelatedErrorExists = false;

    const inputElement = $event.target as HTMLInputElement;
    const files: FileList = inputElement.files;
    const filesToUpload = this.filesToUpload;
    let self = this;
    const maxFileSizeInBytes: number = self.appConfig.getConfig('maxFileUploadSizeInBytes');
    const maxFileNameLength: number = 100;
    const fileNameOffset = 20

    if (!files || files.length === 0) {
      return;
    }

    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        const newFile = new AppFile();

        // nm 030321 - Check file size compared to config >>
        if (file.size > maxFileSizeInBytes) {
          const maxFileSizeinMB = (maxFileSizeInBytes / 1000000).toString();
          self.fileRelatedErrorExists = true;
          newFile.FileError = this.translationPipe.transform('FileSizeTooBig', [maxFileSizeinMB]);
        }

        if (file.name.length > maxFileNameLength && !self.fileRelatedErrorExists) {
          const fileNameEnding = file.name.substring(file.name.length - fileNameOffset, file.name.length);;
          self.fileRelatedErrorExists = true;
          newFile.FileError = this.translationPipe.transform('FileNameTooLong', [fileNameEnding, maxFileNameLength.toString()])
        }

        // nm 030321 - Check file size compared to config <<
        const fileReader = new FileReader();
        let textFromFileLoaded;
        fileReader.onload = function (fileLoadedEvent: any) {
          textFromFileLoaded = fileLoadedEvent.target.result;

          // base 64 encode
          newFile.File = btoa(textFromFileLoaded);
          newFile.Key = '{' + self._chosenTask.Task_GUID + '}';
          newFile.Type = 'App Task';
          newFile.FileName = file.name;

          let d = new Date();
          newFile.Created_DateTime = d.toDateString();
          filesToUpload.push(newFile);
          if (i === files.length - 1) {
            inputElement.value = '';
          }
        };
        fileReader.readAsBinaryString(file);
      }
    }
  }

  public uploadFiles() {

    if (this.filesToUpload.length > 0) {
      this.loading = true;
      let companyRef: string = this.isChosenTaskLevelOTS ? this.selectedCompany.Company_Name : '';

      this.fileService.uploadFiles(this.filesToUpload, companyRef).subscribe(success => {
        this.loading = false;
        const length = this.filesToUpload.length;
        if (success.length === 0) {
          //this.snackBar.open(length - success.length + ' fil/filer eksisterer allerede. ', 'OK', {duration: 3000});
        }
        for (let j = 0; j < length; j++) {
          this.removeFile(this.filesToUpload[0]);
        }
        this.getFiles(this._chosenTask);
      },
        (error: Response) => {
          this.fileUploadErrorResponse = error;
          this.loading = false;
        });
    }
  }

  public removeFile(file: AppFile) {
    const index = this.filesToUpload.indexOf(file);
    if (index > -1) {
      this.filesToUpload.splice(index, 1);
    }
    // Check file size compared to config
    let fileWithError = this.filesToUpload.find(x => x.FileError != null && x.FileError != '');
    if (!fileWithError) {
      this.fileRelatedErrorExists = false;
    }
  }


  private getFiles(task: Task) {
    if (task.Task_GUID != null) {
      this.fileService.getFilesByKey(task.Task_GUID, 'App Task', task.Company_Reference).subscribe(files => {
        this.filesToDownload = [...files]
      });
    }
  }

  public downloadFile(file) {
    let companyRef: string = this.isChosenTaskLevelOTS ? this.selectedCompany.Company_Name : null;
    this.fileService.downloadFile(file.No, companyRef).subscribe(blob => {
      const fileUrl = URL.createObjectURL(blob);
      const nav = window.navigator as any;
      // for IE 10+
      if (nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(blob, file.FileName);
      } else {
        const element = document.createElement('a');
        element.href = fileUrl;
        element.setAttribute('download', file.FileName);
        element.setAttribute('target', '_blank');
        element.dispatchEvent(new MouseEvent('click'));
        URL.revokeObjectURL(fileUrl);
      }
    });
  }

  public getPreviewImage(file: AppFile): Observable<Blob> {
    let companyRef: string = this.isChosenTaskLevelOTS ? this.selectedCompany.Company_Name : null;
    return this.fileService.downloadFile(file.No, companyRef, this.getFileType(file.FileName))
  }


  private setOptionsData() {
    this.startDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{
        begin: {
          year: new Date(this._chosenTask.end).getFullYear(),
          month: new Date(this._chosenTask.end).getMonth() + 1,
          day: new Date(this._chosenTask.end).getDate() + 1
        }, end: { year: 2055, month: 11, day: 20 }
      }],
    };
    this.endDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      disableDateRanges: [{
        begin: { year: 1980, month: 11, day: 20 },
        end: {
          year: new Date(this._chosenTask.start).getFullYear(),
          month: new Date(this._chosenTask.start).getMonth() + 1,
          day: new Date(this._chosenTask.start).getDate() - 1
        }
      }],
    };

    this.completionDatePickerOptions = {
      // other options...
      dateFormat: 'dd/mm/yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
    };
  }

  public setStartDate(event: IMyDateModel) {
    this._chosenTask.start = event.jsdate.toDateString();
    this.setOptionsData();
  }

  public setEndDate(event: IMyDateModel) {
    this._chosenTask.end = event.jsdate.toDateString();
    this.setOptionsData();
  }

  public setCompletionDate(event: IMyDateModel) {
    this._chosenTask.Completed_Date_Time = event.jsdate;
    this._chosenTask.Completed_Date_Time.setHours(12);

    this.setOptionsData();
  }

  private getSalesPersons() {
    this.salesPersonService.getAllSalesPersonsAsSalesPerson().subscribe(result => {
      if (result.length > 0) {
        this.salespersons = result;
        this.currentResourceNo = this.getCurrentResourceNo();
      }
    });
  }

  private getCurrentResourceNo(): string {
    const currentUserNo = this.sessionService.getUserNo();
    if (!currentUserNo) {
      return undefined;
    }

    const loggedInUser = this.salespersons.find(salesperson =>
      salesperson.Code &&
      salesperson.Code.toLowerCase() === currentUserNo.toLowerCase());

    return loggedInUser && loggedInUser.Resource;
  }

  private getItemUsage(task: Task) {
    if (task.Task_GUID != null) {
      this.itemUsageService.GetFromTask(this._chosenTask.Task_GUID).subscribe(result => {
        this.itemUsages = result;
      });
    }
  }

  private getRequisitionLines(task: Task) {
    if (task.Task_GUID != null) {
      this.requisitionLineService.GetAllForTask(this._chosenTask.Task_GUID).subscribe(result => {
        this.requisitionItems = result;
      });
    }
  }

  public setCompletedBy() {
    this._chosenTask.Completed_By = this.loggedInUserNo.toUpperCase();

    let d = new Date();
    this._chosenTask.Completed_Date_Time = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12);

    this.dummyCompletion = {
      date: {
        year: new Date(this._chosenTask.Completed_Date_Time).getFullYear(),
        month: new Date(this._chosenTask.Completed_Date_Time).getMonth() + 1,
        day: new Date(this._chosenTask.Completed_Date_Time).getDate()
      }
    };

  }

  public getNameWithoutType(fileName: String): string {
    var splitName = fileName.split('.');

    if (splitName.length < 2) {
      return splitName[0];
    }

    var subArray = splitName.slice(0, (splitName.length - 1)).join('.');

    return subArray;
  }

  public getFileType(fileName: String): string {
    var splitName = fileName.split('.');
    return splitName[splitName.length - 1];
  }

  public createItemUsages(itemUsages: ItemUsage[]) {
    this.hasCreationError = false;
    itemUsages.forEach(itemUsage => {
      itemUsage.App_Task_GUID = this._chosenTask.Task_GUID;
    })

    var sub = this.itemUsageService.CreateMultiple(itemUsages).subscribe(_ => {
      this.clearChangedQuantityList()
      this.toggleShowItemUsageContent(2);
      this.selectedConfiguration = this._maintenanceObjectConfiguration.PickingList;
      let itemUsageSub = this.itemUsageService.GetFromTask(this._chosenTask.Task_GUID).subscribe(result => {
        this.itemUsages = result;
        itemUsageSub.unsubscribe();
      });
      sub.unsubscribe();
    }, error => {
      this.hasCreationError = true;
      this.creationErrorMessage = this.getBusinessCentralErrorMessage(error);
    });
  }

  private getBusinessCentralErrorMessage(error: any): string {
    let responseText = error && error.text ? error.text() : '';

    try {
      const parsedResponse = JSON.parse(responseText);
      if (parsedResponse && parsedResponse.error && parsedResponse.error.message) {
        return this.removeCorrelationId(parsedResponse.error.message);
      }

      if (typeof parsedResponse === 'string') {
        responseText = parsedResponse;
      }
    } catch (exception) {
      // The API can return the Business Central OData error inside a plain-text response.
    }

    const normalizedResponse = responseText.replace(/\\\"/g, '"');
    const messageMatch = /[\"']?message[\"']?\s*:\s*[\"']?([\s\S]*?)(?=[\"']?\s*}\s*})/i.exec(normalizedResponse);

    if (messageMatch && messageMatch[1]) {
      return this.removeCorrelationId(messageMatch[1]);
    }

    return 'Der er sket en fejl under registrering af vareforbrug.';
  }

  private removeCorrelationId(message: string): string {
    return message.split('CorrelationId:')[0].trim();
  }

  public createItemOrders(itemOrders: RequisitionLine[]) {
    this.hasCreationError = false;
    itemOrders.forEach(itemOrder => {
      itemOrder.App_Task_GUID = this._chosenTask.Task_GUID;

      //TODO: Fix model instead of this hack
      if(!itemOrder.Journal_Batch_Name)
        {
          itemOrder.Journal_Batch_Name = "1";
        }
      if(!itemOrder.Worksheet_Template_Name)
        {
          itemOrder.Worksheet_Template_Name = "1";
        }
    });

    var sub = this.requisitionLineService.CreateMultiple(itemOrders).subscribe(_ => {
      this.getRequisitionLines(this._chosenTask);
      this.clearChangedQuantityList()
      this.toggleShowItemUsageContent(2);
      this.selectedConfiguration = this._maintenanceObjectConfiguration.PickingList;
      let itemOrderSub = this.requisitionLineService.GetAllForTask(this._chosenTask.Task_GUID).subscribe(result => {
        this.requisitionItems = result;
        itemOrderSub.unsubscribe();
      });
      sub.unsubscribe();
    }, error => {
      this.hasCreationError = true;
      this.creationErrorMessage = JSON.parse(error.text()); // Parsing to JSON to get rid of additional quotations
    });
  }

  public openExpandedTextField(propertyName: string, elementId: string) {
    this.isExpandedTextFieldAvailable = true;
    setTimeout(() => {
      document.getElementById(elementId).blur();
      $('#expandedTextFieldModal').on('hidden.bs.modal', () => {
        this.textFieldValue = null;
      })
      this.chosenProperty = propertyName;
      this.textFieldValue = this._chosenTask[propertyName];
      $('#expandedTextFieldModal').modal('show');
    }, 5);

  }

  public closeExpandedTextField(value: string) {
    value !== undefined ? this._chosenTask[this.chosenProperty] = value : this.textFieldValue = null;
    $('#expandedTextFieldModal').modal('hide');
    setTimeout(() => {
      this.isExpandedTextFieldAvailable = false;
    }, 5);
  }

  private findSelectedCompany() {
    if (!!this.companies && !!this._chosenTask) {
      this.selectedCompany = this.companies.find(x => x.Company_Part_URL == this._chosenTask.Company_Reference);
    }
  }

  public setSelectedCompany() {
    if (!!this._chosenTask && !!this.selectedCompany)
      this._chosenTask.Company_Reference = this.selectedCompany.Company_Part_URL;
  }

  /*
    If the company/person logged in isn't OTS, don't allow them to
    edit OTS tasks.
  */
  public isFieldDisabled() {
    return (!this.isSelectedCompanyOTS && this.notificationAlreadyCreated && this.originalTaskLevel === TaskLevel.OTS);
  }

  public onStatusChange(status: string) {
    if (status !== 'completed') {
      this.originalShowCompletedByStamp = false;
    }
    if (status.toLowerCase() === 'active' || status.toLowerCase() === 'completed') {
      this.setResponsible()
    }
  }

  public reset() {
    $('#taskActivityHistoryModal').modal('hide');
    this.originalShowCompletedByStamp = false;
    this.originalTaskLevel = null;
    this.editTitle = false;
    this.showActivityHistory = false;
    this.selectedActivityHistoryTitle = '';
    this.taskActivityHistory = [];
  }

  /**
   * Returns whether the current task is Intercompany or not.
   * E.g.
   * Logged in as OTS working on Elite IT task
   * Logged in as Elite IT working on Task with OTS Task Level.
   * @returns True if the task is Intercompany.
   */
  public isInterCompany(): boolean {
    if (this.isSelectedCompanyOTS) {
      return this._chosenTask.Company_Reference != this.sessionService.getSelectedCompany();
    } else {
      return this._chosenTask.Task_Level !== TaskLevel.Intern;
    }
  }

  clearChangedQuantityList(){
    this.listOfChangedMaintenanceObjects = [];
  }

  //Set the person responsible for the task when the status changes to active or completed, If the user is OTS then OTS Responsible is set instead
  public setResponsible() {
    const loggedInUser = this.salespersons.find(salesperson => salesperson.Code.toLowerCase() === this.sessionService.getUserNo().toLowerCase());
    if (this.isSelectedCompanyOTS) {
      this._chosenTask.OTS_Responsible = loggedInUser.Code;
      this._chosenTask.OTS_Responsible_Name = loggedInUser.Name;
    } else {
      this._chosenTask.Responsible = loggedInUser.Code;
      this._chosenTask.Responsible_Name = loggedInUser.Name;
    }
  }

  toggleEditTitle() {
    this.editTitle = !this.editTitle;
  }

  toggleMaintenanceObjectPicker() {
    let pickerState: string = 'show'
    if (this.isMaintenanceObjectPickerShown) {
      pickerState = 'hide'
    }
    setTimeout(() => {
      $('#maintenanceObjectPicker').modal(pickerState);
    }, 100);
    this.isMaintenanceObjectPickerShown = !this.isMaintenanceObjectPickerShown;
  }

  setMaintenanceObject(event: MaintenanceObject) {
    if (event !== null) {
      this._chosenTask.Maintenance_Object = event.No;
      this._chosenTask.Desciption = event.Description;
    }
  }

  allowedToChangeTitleOrMO(): boolean {
    if (this._chosenTask.Status !== 'Completed' && this._chosenTask.Maintenance_Template_No === 0) {
      return true;
    }
    return false;
  }


  // this functions checks the user activity input if its inside the boundries for that particular activity
  exceedsBoundryValues(taskActivity: TaskActivity): boolean {
    const { Max_Reading, Min_Reading, Reading } = taskActivity;
    if ((Max_Reading !== 0 || Min_Reading !== 0) && (Reading > Max_Reading || Reading < Min_Reading)) {
      return true;
    }
    return false;
  }

  /**
   * The function `getActivityHistory` retrieves the activity history for a specific maintenance object
   * and task activity, then opens a modal with the results.
   */
  getActivityHistory(taskActivity: TaskActivity) {
    const { MO_No, Task_Activity_No, Activity_Description } = taskActivity;

    this.showActivityHistory = false;
    this.selectedActivityHistoryTitle = Activity_Description;
    this.taskActivityHistory = [];

    this.taskActivityService.getActivityHistory(MO_No, Task_Activity_No, this._chosenTask.Maintenance_Template_No).subscribe((value: TaskActivity[]) => {
      this.taskActivityHistory = [...value];
      this.showActivityHistory = true;

      setTimeout(() => {
        const activityHistoryModal = $('#taskActivityHistoryModal');
        activityHistoryModal.off('hidden.bs.modal').on('hidden.bs.modal', () => {
          this.taskActivityHistory = [];
          this.selectedActivityHistoryTitle = '';
          this.showActivityHistory = false;
        });
        activityHistoryModal.modal('show');
      }, 5);
    });
  }

  closeActivityHistoryModal() {
    $('#taskActivityHistoryModal').modal('hide');
  }

  closeErrorModal() {
    $('#errorModal').modal('hide');
  }

  showImgPreview(file: AppFile, index: number) {
    //set the image position in line with the icon, the user clicked on
    this.setImagePosition(index);
    this.getPreviewImage(file).subscribe(blob => {
      const reader = new FileReader();
      reader.readAsDataURL(blob)
      reader.onloadend = () => {
        this.previewImageUrl = reader.result;
        this.hideImagePreview = false;
      }
    })
  }

  hideImgPreview() {
    this.hideImagePreview = true;
  }

  toggle(file: AppFile, index: number) {
    if (this.isFileAnImage(file)) {
      if (this.hideImagePreview) {
        this.showImgPreview(file, index)
      } else {
        this.hideImgPreview()
      }
    }
  }

  isFileAnImage(file: AppFile): boolean {
    const imageFileNames: string[] = ["jpg", "png"];
    //if the fileextension matches any in the imageFileNames array, then return true
    if (imageFileNames.includes(this.getFileType(file.FileName))) {
      return true;
    }
    return false;
  }

  geticonPosition(index: number) {
    return this.fileElements.toArray()[index].nativeElement.getBoundingClientRect();
  }

  setImagePosition(index: number) {
    this.imagePosition.top = Math.round(this.geticonPosition(index).top);
  }

  ListOfPendingMaintenanceObjectsChange(ListofChangedObjects: MaintenanceObject[]){
    this.listOfChangedMaintenanceObjects = ListofChangedObjects;
  }

  getCommunicationLogs(taskNo: string) {
    // If Company_Reference is falsy, return null, Otherwise return Company_Reference
    const companyName = !this._chosenTask.Company_Reference ? null : this._chosenTask.Company_Reference;
    const getLogssubscription = this.communicationLogService.GetCommunicationLogs(taskNo, companyName).subscribe((commLogs: CommunicationLog[]) => {
      this.communicationLogs = [...commLogs];
    }, () => {}, () => {getLogssubscription.unsubscribe()})
  }

  hasCommunicationLogs(): boolean{
    return this.communicationLogs.length > 0 ? true : false;
  }

  createCommunicationLog(logInput: string){
    const communicationLogObject: CommunicationLog = this.communicationLogService.GenerateCommunicationLogObject();
    communicationLogObject.Task_GUID = this._chosenTask.Task_GUID;
    communicationLogObject.Note = logInput;
    communicationLogObject.Task_No = this._chosenTask.No;
    return communicationLogObject;
  }

  callCommunicationLogHTTPService(logInput: string){
      let localComLog = [...this.communicationLogs]
      // If Company_Reference is falsy, return null, Otherwise return Company_Reference
      const companyName = !this._chosenTask.Company_Reference ? null : this._chosenTask.Company_Reference;
      const createLogSub = this.communicationLogService.CreateCommunicationLog(this.createCommunicationLog(logInput), companyName).subscribe((resp: CommunicationLog) => {
        localComLog.splice(0, 0, resp)
        this.communicationLogs = [...localComLog];
      }, () => {}, () => {createLogSub.unsubscribe()})
  }

  getErrorMessage(taskActivity: TaskActivity): string{
    let errorMsg = `${this.activityErrorMessage} ${taskActivity.Min_Reading} - ${taskActivity.Max_Reading}` ;
    return errorMsg;
  }


}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/modal-task/modal-task.component.ts